import { observer } from "mobx-react";
import { languageStore, navigationStore } from "stores";
import SidebarNavigation from 'components/AdminPage/SidebarNavigation';
import { useLocation, useParams } from "react-router";
import useUserRoleDepartmentByParams from "./useUserRoleDepartmentByParams";

interface Props {
    children: React.ReactNode
}

const DepartmentDetailsPage = observer((props: Props) => {
    const department = useUserRoleDepartmentByParams();
    const { pathname } = useLocation();
    const { id } = useParams<{ id: string }>();

    if (!department) return null;

    return (
        <div>
            <div className='text-left flex-1'>
                <h2 className='mt-2 mb-5'>
                    <button className='mr-2 text-red' onClick={() => navigationStore.push('/admin/departments')}>
                        &larr;
                    </button>
                    {`${languageStore.get('edit')} ${languageStore.get('department', false)}`} ({department.name})
                </h2>
            </div>

            <div className='flex'>
                <SidebarNavigation
                    items={[
                        {
                            title: languageStore.get('department'),
                            defaultExpanded: true,
                            subItems: [
                                {
                                    label: languageStore.get('general'),
                                    onClick: () => navigationStore.push(`/admin/departments/${id}`),
                                    isSelected: pathname === `/admin/departments/${id}`
                                },
                                {
                                    label: languageStore.get('users'),
                                    onClick: () => navigationStore.push(`/admin/departments/${id}/users`),
                                    isSelected: pathname === `/admin/departments/${id}/users`
                                }
                            ]
                        }
                    ]}
                />

                <div className='flex-1 ml-6'>
                    {props.children}
                </div>
            </div>
        </div>
    )

})

export default DepartmentDetailsPage;